import { Provider } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";
import { Resource } from "../../models/personnel.model";
import { HrRepository } from "../../repositories/hr.repository";

interface GetAllActivePEUseCaseParam {
  startDate: string;
  endDate: string;
}

export class GetAllActivePEUseCase
  implements UseCase<GetAllActivePEUseCaseParam, Resource[]>
{
  constructor(private repo: HrRepository) {}
  execute(param: GetAllActivePEUseCaseParam): Observable<Resource[]> {
    return this.repo.getAllActivePE(param.startDate, param.endDate);
  }
}

const getAllActivePEUseCaseFactory = (repo: HrRepository) =>
  new GetAllActivePEUseCase(repo);

export const getAllActivePEUseCaseProvider: Provider = {
  provide: GetAllActivePEUseCase,
  useFactory: getAllActivePEUseCaseFactory,
  deps: [HrRepository],
};
